import React, { useState, useEffect, useCallback, useRef } from 'react';
import classnames from 'classnames';
import { Typography } from 'antd';
import useDimensions from 'hooks/useDimensions';

const ContentOverlay = ({ className, content, minHeight = 45, extra=null, contentClass }) => {
    const [contentHeight, setContentHeight] =  useState(minHeight);
    const [isExpandable, setIsExpandable] =  useState(false);
    const [expanded, setExpanded] =  useState(false);
    const contentRef = useRef();
    const [ref, dimension] = useDimensions();

    useEffect(() => {
        const setExpansionState = () => {
            const contentElem = contentRef.current;
            if (contentElem) {
                setIsExpandable(contentElem.offsetHeight > minHeight);
            }
        }
        setExpansionState();
        window.addEventListener('resize', setExpansionState);
        return () => window.removeEventListener('resize', setExpansionState);
    }, [content, minHeight, contentRef, dimension]);

    const onViewClick = useCallback(() => {
        setExpanded(!expanded);
        setContentHeight(expanded ? minHeight : 'unset');
    }, [expanded, minHeight]);

    return (
        <div className={classnames('content-overlay-wrapper d-flex flex-column', className)}>
            <div className={classnames('content-wrapper', {'blur-content': isExpandable && !expanded})} style={{ maxHeight: contentHeight, overflow: 'hidden' }}>
                <div className={classnames('content', contentClass)} ref={r => {
                    contentRef.current = r;
                    ref(r);
                }}>
                    {content}
                    {extra}
                </div>
            </div>
            {isExpandable && <Typography.Link className="m-t-xs prevent-disable" onClick={onViewClick}>{expanded ? '...Show less' : '...Show more'}</Typography.Link>}
        </div>
    );
};

export default ContentOverlay;